import * as React from 'react';
import { useTranslate } from 'react-admin';

export default ({ record }: any) => {
    const translate = useTranslate();
    return (
        <span>
            {record
                ? translate('resources.posts.edit.title', {
                      title: record.title,
                  })
                : ''}
        </span>
    );
};
